import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
// Styling
import './navigation.scss'
import { ContentfulMainNavigationLink } from 'utils/queries'

// Props
interface LinkProp {
  title: string
  url: string
}

interface Props {
  links: ContentfulMainNavigationLink[]
}

export const Link: React.FC<LinkProp> = ({ title, url }) => {
  const to = url.startsWith('/') ? url : `/${url}`
  return (
    <li className={'main-nav__item'}>
      <GatsbyLink
        className={'main-nav__link'}
        partiallyActive={true}
        activeClassName={'main-nav__link--active'}
        to={to}
      >
        {title}
      </GatsbyLink>
    </li>
  )
}

export const Navigation: React.FC<Props> = ({ links }) => (
  <nav className="main-nav">
    <ul className="main-nav__list">
      {links.map((link) => {
        const isExternal = !!link.externalUrl
        const url = isExternal
          ? link.externalUrl
          : link.page?.slug
          ? `/${link.page.slug}`
          : '#'
        return (
          <li key={link.id} className="main-nav__item">
            {isExternal ? (
              <a className="main-nav__link" href={url}>
                {link.title}
              </a>
            ) : (
              <GatsbyLink
                className="main-nav__link"
                to={url || '#'}
                partiallyActive={true}
                activeClassName="main-nav__link--active"
              >
                {link.title}
              </GatsbyLink>
            )}
          </li>
        )
      })}
    </ul>
  </nav>
)
